export default __webpack_public_path__ + "static/media/AMP_Portal_Training_091521_LO12.64a39641.pdf";